/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ApiCreateDocumentGenerationJob = {
    reference_files: Array<number>;
    processing_type?: ApiCreateDocumentGenerationJob.processing_type;
    desired_termination_state: string;
    parser_overrides?: any;
    metadata?: any;
};
export namespace ApiCreateDocumentGenerationJob {
    export enum processing_type {
        CAP_TABLE = 'CAP_TABLE',
        FINANCIALS = 'FINANCIALS',
        FINANCIAL_MAPPING = 'FINANCIAL_MAPPING',
    }
}

